<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>名称：</label>
                <el-input v-model="search_Obj.f_name" clearable></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="name" label="名称" sortable="custom"></el-table-column>
                <el-table-column prop="order_index" label="排序" sortable="custom"></el-table-column>
                <el-table-column prop="isshow" label="是否显示" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.isshow, "yesNo") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看轮播图"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'bannerList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '轮播图',
            menu_id: 7050,
            list_url: "/api/admin/banner/list",
            search_Obj: {
                f_name: '',
            },
            del_Obj:{
                url:'/api/admin/banner/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['yesNo'],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
        };
    },
    methods: {}
};
</script>